import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Window } from "@progress/kendo-react-dialogs";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import DavetliKatilimciService from "../../../services/srv-davetli/DavetliKatilimciService";
import LoadingPanel from "../../../components/sys-toolbox/LoadingPanel";

function pick(item, ...keys) {
  if (!item) return undefined;
  for (const key of keys) {
    if (item[key] !== undefined && item[key] !== null) return item[key];
  }
  return undefined;
}

function GuestParticipantQrDetail({ dataItem, onClose }) {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [loadError, setLoadError] = useState(false);
  const [logs, setLogs] = useState([]);

  const katilimciId = pick(
    dataItem,
    "davetlI_KATILIMCI_ID",
    "dAVETLI_KATILIMCI_ID",
    "DAVETLI_KATILIMCI_ID",
  );
  const max = Math.max(
    1,
    pick(dataItem, "toplaM_DAVETLI_SAYISI", "TOPLAM_DAVETLI_SAYISI") ?? 1,
  );
  const used = logs.length;
  const hakkiDoldu = used >= max ? "EVET" : "HAYIR";

  useEffect(() => {
    if (!katilimciId) return;
    let cancelled = false;
    setLoading(true);
    setLoadError(false);
    DavetliKatilimciService.getQrLogs(katilimciId)
      .then((res) => {
        if (cancelled) return;
        const list = Array.isArray(res) ? res : res?.data ?? [];
        setLogs(list);
      })
      .catch(() => {
        if (cancelled) return;
        setLoadError(true);
        setLogs([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [katilimciId]);

  const formatDate = (value) => {
    if (!value) return "-";
    try {
      return new Intl.DateTimeFormat(i18n.language || "tr", {
        dateStyle: "short",
        timeStyle: "short",
      }).format(new Date(value));
    } catch {
      return String(value);
    }
  };

  return (
    <Window
      title={t("qr_scan_details")}
      onClose={onClose}
      stage={window.innerWidth < 1000 ? "FULLSCREEN" : "DEFAULT"}
      initialHeight={"60vh"}
      initialWidth={"50%"}
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        position: "fixed",
        zIndex: 10000,
      }}
    >
      {loading ? <LoadingPanel /> : null}
      <div style={{ padding: 12 }}>
        <div style={{ marginBottom: 16, lineHeight: 1.6 }}>
          <div>
            <strong>{t("name")}:</strong>{" "}
            {`${pick(dataItem, "ad", "AD") ?? ""} ${
              pick(dataItem, "soyad", "SOYAD") ?? ""
            }`.trim() || "-"}
          </div>
          {!loading && !loadError ? (
            <>
              <div>
                <strong>{t("qr_quota_full")}:</strong>{" "}
                {t(String(hakkiDoldu).toLowerCase())}
              </div>
              <div>
                <strong>{t("qr_scan_usage")}:</strong> {used}/{max}
              </div>
            </>
          ) : null}
          {loadError ? (
            <div style={{ color: "#c00", marginTop: 8 }}>
              {t("qr_scan_logs_load_error")}
            </div>
          ) : null}
        </div>

        {!loading && !loadError && logs.length === 0 ? (
          <div style={{ marginBottom: 12 }}>{t("qr_scan_logs_empty")}</div>
        ) : null}

        {!loadError ? (
          <Grid data={logs} style={{ maxHeight: "40vh" }}>
            <GridColumn
              field="crE_DATE"
              title={t("qr_scan_date")}
              cell={(props) => (
                <td>
                  {formatDate(
                    pick(
                      props.dataItem,
                      "crE_DATE",
                      "cRE_DATE",
                      "CRE_DATE",
                      "creDate",
                    ),
                  )}
                </td>
              )}
            />
            <GridColumn
              field="crE_USER_AD_SOYAD"
              title={t("qr_scanned_by")}
              cell={(props) => {
                const name = pick(
                  props.dataItem,
                  "crE_USER_AD_SOYAD",
                  "cRE_USER_AD_SOYAD",
                  "CRE_USER_AD_SOYAD",
                  "creUserAdSoyad",
                );
                const userId = pick(
                  props.dataItem,
                  "crE_USER",
                  "cRE_USER",
                  "CRE_USER",
                  "creUser",
                );
                return (
                  <td>{name || (userId != null ? String(userId) : "-")}</td>
                );
              }}
            />
          </Grid>
        ) : null}
      </div>
    </Window>
  );
}

export { GuestParticipantQrDetail };
